import React from "react";
import { ITheme } from "../../Layout/themes";
import { makeStyles, createStyles } from "@material-ui/styles";
// import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

const useStyles = makeStyles(({ palette, breakpoints }: ITheme) => {
  return createStyles({
    root: {
      display: "flex",
      minHeight: 71,
      borderRadius: 5,
      boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#f3f3f3",
      overflow: "hidden",
      marginTop: 20,
      marginBottom: 20
    },
    iconBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 42,
      backgroundColor: "#f0c000" // palette.error.main, this color just for error info sign
    },
    icon: {
      color: "#000000",
      fontSize: 32
    },
    messageBox: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      paddingLeft: 10,
      paddingTop: 20,
      paddingBottom: 20,
      fontSize: "1.4rem",
      color: palette.text.secondary
      // [breakpoints.down("sm")]: {
      //   paddingLeft: 10
      // }
    }
  });
});
export const ErrorBarWithChild = (props)=> {
  const classes = useStyles({});

  if (!props.children) {
    return null;
  }

  return (
    <div className={classes.root}>
      <div className={classes.iconBox}>
        <PriorityHighIcon className={classes.icon} />
      </div>
      <div className={classes.messageBox}>
          {props.children}
      </div>
    </div>
  );

}

export const ErrorBar = ({ message }: any) => {
  const classes = useStyles({});

  if (!message) {
    return null;
  }

  const msgs = message.split("\n\t");
  return (
    <div className={classes.root}>
      <div className={classes.iconBox}>
        <PriorityHighIcon className={classes.icon} />
      </div>
      <div className={classes.messageBox}>
        {msgs.map((element: string) => (
          <div key={element}>{element}</div>
        ))}
      </div>
    </div>
  );
};
